import { env } from '@/config/env';

export default function Footer() {
  return (
    <footer className="border-t bg-white py-4 text-center text-sm text-gray-500">
      © {new Date().getFullYear()} {env.appName}. All rights reserved.
    </footer>
  );
}
